import moment from 'moment';

import { aTypeRebook, aTypeRebookPreload } from 'actions/shared.types';
import { selectCurrentSalonServices } from 'selectors/currentSalon.selectors';
import asArray from 'utils/arrays/asArray.util';
import { fromAnyToUglyJson } from 'utils/converters/json.util';
import { combineDateStartTime } from 'utils/date/combine.util';
import repairDstTransition from 'utils/date/repairDstTransition.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import logger from 'utils/logger.util';

import { addService, pickClient } from 'booking/actions';
import compareStartTimes from 'lib/sortTimesAscending.util';

const L = logger('xeRebook'); // eslint-disable-line no-unused-vars

const USE_JSON_IN_LOG = false;

const isDst = (date) => moment(date).isDST();

const findService = (options) => {
  const serviceId = options?.serviceId;

  if (!serviceId) return void 1; // no point continuing

  for (const categoryService of asArray(options?.categoryServices)) {
    for (const service of asArray(categoryService?.services)) {
      if (serviceId === service?.id) return service;
    }
  }

  return void 1; // not found
};

const generateNewService = (options) => {
  const ogService = options?.service ?? {};

  const procedure = options?.procedure;

  const stylistId = procedure?.stylist?.id;
  const startTime = procedure?.start_time;

  const ngService = {
    ...ogService,

    unedited: true,

    service_id: ogService?.id,

    // used to be: start_time: startTime,
    start_time: moment(startTime),

    stylist_id: stylistId,
    stylist: { id: stylistId },

    duration: procedure?.duration, // guan added for GS-4847 and GS-4850
    price: procedure?.price, // guan added for GS-4847 and GS-4850

    appointment: { ...(options?.appointment ?? {}) },
  };

  delete ngService.appointment.id;

  return ngService;
};

const xeRebook = (appointment, from, newDate, oldDate) => {
  const j = USE_JSON_IN_LOG ? fromAnyToUglyJson : alwaysNoop;

  L.debug('()', ...L.O({ appointment, from, newDate, oldDate }));

  return async (dispatch, getState) => {
    const client = appointment?.client;

    if (client) {
      const pickClientOptions = pickClient({ ...client, id: client?.id ?? client?.pk, has_no_appointments: false });
      const pickClientResult = await dispatch(pickClientOptions);
      L.debug('()', 'pickClient', pickClientResult, '<-', pickClientOptions, j(pickClientOptions));
    }

    const procedures = asArray(appointment?.procedures).map((p) => ({ ...(p ?? {}) }));
    for (const procedure of procedures) {
      procedure.start_time = repairDstTransition({
        isDstOld: isDst(oldDate),
        isDstNew: isDst(newDate),
        date: moment(combineDateStartTime({ date: newDate, time: procedure?.start_time })),
        returnType: 'moment',
      });
    }

    procedures.sort(compareStartTimes);

    for (const procedure of procedures) {
      const foundService = findService({
        serviceId: procedure?.service?.id,
        categoryServices: selectCurrentSalonServices(getState()),
      });

      if (!foundService) continue;

      const booking = generateNewService({ service: foundService, procedure, appointment });

      const preloadOptions = { type: aTypeRebookPreload.name, booking };
      const preloadResult = await dispatch(preloadOptions);
      L.debug('()', 'preload', preloadResult, '<-', preloadOptions, j(preloadOptions));

      const addServiceOptions = addService(booking);
      const addServiceResult = await dispatch(addServiceOptions);
      L.debug('()', 'addService', addServiceResult, '<-', addServiceOptions, j(addServiceOptions));
    } // for procedure

    const rebookOptions = { type: aTypeRebook.name, services: procedures, client, oldAppointment: appointment, from };
    const rebookResult = await dispatch(rebookOptions);
    L.debug('()', 'rebook', rebookResult, '<-', rebookOptions, j(rebookOptions));
  };
};

export default xeRebook;
